export enum BusinessFrontPageHighlightType {
    Category = 0,
    Characteristic = 1,
    AllReferences = 2,
    DiscountedReferences = 3,
    Contact = 4
}
export class BusinessFrontPageHighlight {
    public uniqueIdentifier: string = '';
    public title: string | null = null;
    public value: number | null = null;
    public imageUrl: string | null = null;
    public type: BusinessFrontPageHighlightType = BusinessFrontPageHighlightType.Category;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): BusinessFrontPageHighlight {
        const businessFrontPageHighlight: BusinessFrontPageHighlight = new BusinessFrontPageHighlight();

        businessFrontPageHighlight.uniqueIdentifier = this.uniqueIdentifier;
        businessFrontPageHighlight.title = this.title;
        businessFrontPageHighlight.value = this.value;
        businessFrontPageHighlight.imageUrl = this.imageUrl;
        businessFrontPageHighlight.type = this.type;

        return businessFrontPageHighlight;
    }
}
